<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container">
<img alt="images" src="images/pg2-1.jpg"/>
</div>
<h1 class="title"><a id="page_1"><span class="bold">A — Z</span></a></h1><a id="page_1">
<p class="author"><span class="bold">of</span></p>
<p class="author1"><span class="bold">Sewing for Smockers</span></p>
<div class="img_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?3fe4f141